import axios, { AxiosInstance } from 'axios';
import { initAjaxHandlersCommon } from './ajax-handlers-common';

export const createAxiosInstance = (): AxiosInstance => {
    const instance = axios.create();

    initAjaxHandlersCommon(instance);

    return instance;
};

export const createMainAppMicroserviceInstance = (mainAppUrl: string, cpUrl: string) => {
    const instance = createAxiosInstance();

    instance.interceptors.request.use(config => {
        if (config.url?.startsWith(mainAppUrl)) {
            config.url = config.url.replace(mainAppUrl, cpUrl);
            const parts: string[] = config.url.split('?');

            if (parts[0] === cpUrl) {
                config.url = parts.shift() + '/' + (parts.length ? '?' + parts.join('?') : '');
            }
        }

        return config;
    });

    return instance;
};
